/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Holster_EmptyInputs */

const cs_property_ai_holster_empty = /** @type {(inputs: Property_Ai_Holster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné nepublikované AI fotky.`)
};

const en_property_ai_holster_empty = /** @type {(inputs: Property_Ai_Holster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No unpublished AI photos.`)
};

/**
* | output |
* | --- |
* | "No unpublished AI photos." |
*
* @param {Property_Ai_Holster_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_holster_empty = /** @type {((inputs?: Property_Ai_Holster_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Holster_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_holster_empty(inputs)
	return cs_property_ai_holster_empty(inputs)
});